import { ReactElement, useRef, useState } from 'react'
import BaseDrawer from '../../../ui-components/modals/BaseDrawer'
import { useModal, create } from '@ebay/nice-modal-react'
import { AddToCartDrawerProps } from '../common/interfaces'
import miscellaneousVehicle, {
  isMiscellaneousVehicle,
} from '../../search/Results/utils/miscellaneousVehicle'
import CartDropdown from './CartDropdown'
import { Vehicle } from '../../../store/models/Vehicles'
import StoreCards from './StoreCards'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { CartMode } from '../../../store/models/ShoppingCartModels'
import { getCartMode } from '../../../../libs/cart/src'

export const AddToCartDrawer = create<AddToCartDrawerProps>(
  (props: AddToCartDrawerProps): ReactElement | null => {
    const { searchStore, seller, activeLocation, product, currentVehicle } =
      props

    const modal = useModal()
    const dropDownRef = useRef(undefined)

    const [vehicle, setVehicle] = useState<Vehicle>(currentVehicle)

    const cartVehicles = useSelector(
      (state: RootState) => state.cart.cartData.vehicles
    )

    const vehicles = cartVehicles?.map((cV) => cV.vehicle) || []
    const isMultiCartMode = getCartMode() === CartMode.MULTI_VEHICLE

    if (isMultiCartMode && !vehicles.some(isMiscellaneousVehicle)) {
      vehicles.push(miscellaneousVehicle)
    }

    if (!product) return null

    const body = (
      <Body>
        {isMultiCartMode && vehicles?.length > 1 && (
          <CartDropdown
            carts={vehicles}
            selectedCart={vehicle}
            onChange={setVehicle}
            dropDownRef={dropDownRef}
          />
        )}
        <StoreCards
          vehicle={vehicle}
          seller={seller}
          product={product}
          activeLocation={activeLocation}
          searchStore={searchStore}
        />
      </Body>
    )

    return (
      <BaseDrawer
        open={modal.visible}
        title="moreLocations"
        onClose={modal.remove}
        body={body}
        width="533px"
        clickOutsideCustomRefs={[dropDownRef]}
      />
    )
  }
)

const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`

export default AddToCartDrawer
